const desiredFractionDigits = 9;
const defaultPercentageOptions = {
  minimumFractionDigits: desiredFractionDigits,
  style: "percent"
};
const exponent = (s) => Number(Number(s).toExponential().split("e")[1]);
const fractionDigitsFor = (s, defaultDigits) => {
  const e = exponent(s);
  return e <= -1 * defaultDigits ? -1 * e + 1 : defaultDigits;
};
const format = (num, options) => new Intl.NumberFormat(void 0, options).format(num);
export const formatNumber = (num, { digits, ...options } = {}) => format(num, {
  minimumFractionDigits: options.minimumDigits,
  maximumFractionDigits: fractionDigitsFor(num, digits != null ? digits : desiredFractionDigits),
  ...options
});
export const formatPercentage = (num, { digits, ...options } = {}) => format(num, {
  ...defaultPercentageOptions,
  maximumFractionDigits: fractionDigitsFor(num * 100, digits != null ? digits : desiredFractionDigits),
  ...options
});
export const formatTrend = (num, options = {}) => (options.percentage === true ? formatPercentage : formatNumber)(num, { signDisplay: "exceptZero" });
const defaultReadableNumberOptions = {
  compactDisplay: "short",
  maximumFractionDigits: desiredFractionDigits,
  notation: "compact"
};
export const formatReadableNumber = (num) => {
  if (Math.abs(num) < 1e3) {
    return new Intl.NumberFormat("en", {
      maximumFractionDigits: fractionDigitsFor(num, desiredFractionDigits)
    }).format(num);
  }
  return new Intl.NumberFormat("en", defaultReadableNumberOptions).format(num).toLowerCase();
};
